import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  BALANCE_DOWNPAYMENT,
  DOWNPAYMENT,
  EXISTING_OWNER_PAYMENT,
  ExitingOwners,
  JointOwners,
  LOAN_TO_VALUE,
  COMPLETION_PERIOD,
  EXERCISE_PERIOD,
  TWO_TO_ONE,
} from '@/constants/others/part-share-purchase';
import { PAGE } from '@/constants/common';
import { FormTypes } from '.';
import * as calculatorConfig from '@/config/base-config.json';

export const initialState = {
  formField: {
    propertyName: '',
    valuationPrice: '',
    existingLoan: '',
    numberOfJointOwners: JointOwners.TWO,
    numberOfExitingOwners: ExitingOwners.ONE,
    jointOwners: TWO_TO_ONE.jointOwners,
    exitingOwners: TWO_TO_ONE.exitingOwners,
    exitingOwnersPaymentData: [EXISTING_OWNER_PAYMENT],
    downpaymentPercent: DOWNPAYMENT.DEFAULT,
    balanceDownpaymentPercent: BALANCE_DOWNPAYMENT,
    loanPercent: LOAN_TO_VALUE.DEFAULT,
    legalFee: calculatorConfig.legal_fee.toString(),
    others: '',
    loanTenure: '30',
    interest: '2.5',
    indexOfOwner: 'joint-owner-0',
    otpDate: new Date().toString(),
    completionPeriod: COMPLETION_PERIOD.DEFAULT.toString(),
    exercisePeriod: EXERCISE_PERIOD.DEFAULT.toString(),
  } as FormTypes,
  loading: true,
  from: '' as PAGE | '',
};

export const partSharePurchaseSlice = createSlice({
  name: 'partSharePurchase',
  initialState,
  reducers: {
    updateDataForm: (
      state,
      action: PayloadAction<
        FormTypes & {
          from: PAGE | '';
        }
      >,
    ) => {
      const { from, ...rest } = action.payload;

      state.formField = rest;
      state.from = action.payload.from;
    },
    updateFrom: (state, action: PayloadAction<PAGE>) => {
      state.from = action.payload;
    },
    reset: () => {
      return initialState;
    },
  },
  extraReducers: () => {},
});

export const { updateDataForm, updateFrom, reset } = partSharePurchaseSlice.actions;

export default partSharePurchaseSlice.reducer;
